var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.current_user_details.user_type == 'company')?_c('company-jobs-created',{attrs:{"type":"fullwidth"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }